import { environment } from '@vivli/core/environments';
import { AssignedAppTypeEnum } from '@vivli/shared/infrastructure/enum';
import { IAssignedAppType } from '@vivli/core/infrastructure/interface';
import { useEffect, useState } from 'react';

export const useAssignedAppType = (): IAssignedAppType => {
    const [type, setType] = useState<AssignedAppTypeEnum>(null);
    const [isAmr, setIsAmr] = useState<boolean>(false);

    useEffect(() => {
        const loweredHost = window.location.host.toLowerCase();
        const isLocalUrl = loweredHost.includes('localhost');
        const isAmrUrl = loweredHost.includes(AssignedAppTypeEnum.Amr.toLowerCase());

        // escape for localhost
        if (isLocalUrl) {
            setType(environment.assignedAppType);
            setIsAmr(environment.assignedAppType === AssignedAppTypeEnum.Amr);
            return;
        }

        setType(isAmrUrl ? AssignedAppTypeEnum.Amr : AssignedAppTypeEnum.Default);
        setIsAmr(isAmrUrl);
    }, []);

    return {
        type,
        isAmr
    };
};
